import { apiClient } from '@/shared/api/http-client';

import type {
    AddPracticeLocationResult,
    PracticeDetails,
    PracticeLocation,
    SavePracticeLocationInput,
    UpdatePracticeInput,
} from '../model/practice.types';

export const practiceApi = {
    getDetails: async (signal?: AbortSignal): Promise<PracticeDetails> => {
        return apiClient.get('/practices/me', signal);
    },
    listLocations: async (signal?: AbortSignal): Promise<PracticeLocation[]> => {
        return apiClient.get('/practices/me/locations', signal);
    },
    update: async (data: UpdatePracticeInput, signal?: AbortSignal): Promise<void> => {
        return apiClient.patch('/practices/me', data, signal);
    },
    addLocation: async (
        data: SavePracticeLocationInput,
        signal?: AbortSignal,
    ): Promise<AddPracticeLocationResult> => {
        return apiClient.post('/practices/me/locations', data, signal);
    },
    updateLocation: async (
        locationId: string,
        data: SavePracticeLocationInput,
        signal?: AbortSignal,
    ): Promise<void> => {
        return apiClient.patch(`/practices/me/locations/${locationId}`, data, signal);
    },
    removeLocation: async (locationId: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.delete(`/practices/me/locations/${locationId}`, signal);
    },
    setDefaultLocation: async (locationId: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.post(`/practices/me/locations/${locationId}/default`, undefined, signal);
    },
};
